import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "toast"
}
const _hoisted_2 = ["src"]

import { watch } from "vue";
import { TOAST_ICON } from "../consts/common";
export type ToastProps = {
  modelValue: boolean;
  message: string;
  state?: number; // 0:success, 1: fail , 2: alert していない場合は0
  timeout?: number;
};
// APIを公開
interface Emits {
  (e: "update:modelValue", value: boolean): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
    modelValue: { type: Boolean },
    message: {},
    state: {},
    timeout: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

__expose({
  close,
});

const props = __props;
const emit = __emit;

function close() {
  emit("update:modelValue", false);
}

function backgroundColor() {
  if (props.state == 0) {
    return "#EEF9F3";
  } else if (props.state == 1) {
    return "#FFF2F3";
  } else if (props.state == 2) {
    return "rgba(254, 250, 231, 1)";
  }
  return "#EEF9F3";
}

watch<boolean>(
  () => props.modelValue,
  (newValue) => {
    if (props.timeout && newValue) {
      setTimeout(() => {
        emit("update:modelValue", false);
      }, props.timeout);
    }
  }
);
watch<number | undefined>(
  () => props.timeout,
  (newValue) => {
    if (newValue && props.modelValue) {
      setTimeout(() => {
        emit("update:modelValue", false);
      }, props.timeout);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "toast-layout",
    style: _normalizeStyle([_ctx.modelValue ? 'z-index: 999;' : 'z-index: 0; visibility: hidden;'])
  }, [
    _createVNode(_Transition, {
      name: "toast-fade",
      style: _normalizeStyle({ background: backgroundColor() })
    }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("img", {
                src: _unref(TOAST_ICON)[_ctx.state || 0]
              }, null, 8 /* PROPS */, _hoisted_2),
              _createElementVNode("p", null, _toDisplayString(_ctx.message), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["style"])
  ], 4 /* STYLE */))
}
}

})